<template>
  <div id="app">
   <nav class="navbar navbar-expand-lg navbar-custom shadow-sm sticky-top">
  <div class="container">

    <!-- Logo -->
    <a class="navbar-brand d-flex align-items-center" href="#">
        <img src="./assets/airtimelogo.png" alt="">
        <!-- <span class="ms-2 fw-bold text-dark">BambaSpot</span> -->
    </a>

    <!-- Mobile Toggle Button -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navbar Menu -->
    <div class="collapse navbar-collapse" id="navbarMenu">
      <ul class="navbar-nav ms-auto">

        <li class="nav-item">
          <a class="nav-link text-dark" href="https://airtimetocash.co.ke">Home</a>
        </li>

        <li class="nav-item" v-on:click="closeMenu()">
          <router-link class="nav-link text-dark"  to="/" :class="{ active: $route.path === '/' }" >Convert</router-link>
        </li>

        <li class="nav-item" v-on:click="closeMenu()">
          <router-link class="nav-link text-dark" to="/purchase" :class="{ active: $route.path === '/purchase' || $route.name === 'purchase.pinless' }">Safaricom</router-link>
        </li>

        <li class="nav-item" v-on:click="closeMenu()">
          <router-link  class="nav-link text-danger" :class="{ active: $route.path === '/airtel' }" to="/airtel">Airtel</router-link >
        </li>
         <li class="nav-item" v-on:click="closeMenu()">
          <router-link  class="nav-link text-dark" :class="{ active: $route.path === '/offers' }" to="/offers">Offers</router-link >
        </li>
         <li class="nav-item" v-on:click="closeMenu()">
          <router-link  class="nav-link text-dark" :class="{ active: $route.path === '/history' }" to="/history">History</router-link >
        </li>
         <li class="nav-item" v-on:click="closeMenu()">
          <router-link  class="nav-link text-dark" :class="{ active: $route.path === '/blogs' }" to="/blogs">Blogs</router-link >
        </li>

      </ul>
    </div>

  </div>
</nav>

    <!-- Page content -->
    <main>
      <router-view />
    </main>
  </div>
</template>


<script>
    // import moment from 'moment'
    export default {
        name: 'Index',
        components: {

        },
        data(){
            return {
               message:{discount:'0',credit:'0',amount:'0',type:'airtime',receiving_no:'',source:'web-portal'},
                role:'false',
                phone:'',

            }
        },
        created(){

        },
        methods: {
            closeMenu(){
           const navbar = document.getElementById('navbarMenu')
            const bsCollapse = bootstrap.Collapse.getOrCreateInstance(navbar)
          bsCollapse.hide()
           }
        },
    }

</script>





// WEBPACK FOOTER //
// src/App.vue